var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "outer alert-sticky-wrapper",
      attrs: { id: "menu-alert-section" },
    },
    [
      _c("content-container", [
        _vm.url
          ? _c("a", { staticClass: "inner row", attrs: { href: _vm.url } }, [
              _vm.title
                ? _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "copy-wrapper" }, [
                _vm.copy
                  ? _c("div", { staticClass: "copy" }, [
                      _vm._v(_vm._s(_vm.copy)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "banner-icon-wrapper" },
                  [
                    _c(
                      "icon-base",
                      {
                        attrs: {
                          width: "10px",
                          height: "10px",
                          iconName: "Click to visit link",
                        },
                      },
                      [_c("icon-arrow-right")],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ])
          : _c("div", { staticClass: "inner row" }, [
              _vm.title
                ? _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.copy
                ? _c("div", { staticClass: "copy" }, [_vm._v(_vm._s(_vm.copy))])
                : _vm._e(),
            ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }